/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Aspect_LabelInputs */

const cs_templates_aspect_label = /** @type {(inputs: Templates_Aspect_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formát`)
};

const en_templates_aspect_label = /** @type {(inputs: Templates_Aspect_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aspect / format`)
};

/**
* | output |
* | --- |
* | "Aspect / format" |
*
* @param {Templates_Aspect_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_aspect_label = /** @type {((inputs?: Templates_Aspect_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Aspect_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_aspect_label(inputs)
	return cs_templates_aspect_label(inputs)
});